import { useMediaQuery } from '@mui/material';

const UseScreenOrientation = (orientation = 'portrait') => {
    const matches = useMediaQuery(`@media (orientation: ${orientation})`);
    return matches;
};

export default UseScreenOrientation;
